/**
 * Thrown by getSummaryData when fd-core-responses replies HTTP 202 to signal
 * that the survey's data is still being rehydrated from BigQuery.
 *
 * Carries the parsed Retry-After value so the caller can schedule the next
 * poll at the upstream-suggested cadence.
 */
export class RehydrationInProgressError extends Error {
  readonly retryAfterSeconds: number

  constructor(retryAfterSeconds: number) {
    super('Survey rehydration in progress')
    this.name = 'RehydrationInProgressError'
    this.retryAfterSeconds = retryAfterSeconds
  }
}

const DEFAULT_RETRY_AFTER_SECONDS = 60

export const parseRetryAfter = (header: unknown): number => {
  const parsed = parseInt(String(header ?? ''), 10)
  return Number.isFinite(parsed) && parsed > 0
    ? parsed
    : DEFAULT_RETRY_AFTER_SECONDS
}
